import store from "@/store";
const setUserID = () => store.dispatch("auth/setUserID");
const setLastRequest = ({ url, result, status }) =>
  store.dispatch("setLastRequest", { url, result, status });

export const apiUrl = (endpoint) =>
  `${process.env.VUE_APP_APIURL}/api/v1/${endpoint}`;

export async function addStandardFields(
  body,
  addPrompt,
  addJourneyId,
  addUserId
) {
  if (addPrompt) {
    body.prompt = store.state.prompt;
  }
  if (addJourneyId) {
    body.journeyId = store.state.journeyId;
  }
  if (addUserId) {
    await setUserID();
    body.userId = store.state.auth.userId;
  }
  return body;
}

// Resolves to { request, response: { result, status } }; status is 0 if the network failed
const fetchData = async (
  endpoint,
  body,
  addPrompt = true,
  addJourneyId = true,
  addUserId = true
) => {
  await addStandardFields(body, addPrompt, addJourneyId, addUserId);
  const url = apiUrl(endpoint);
  let status = 0;
  let responseBody;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      credentials: "include",
    });
    status = response.status;
    responseBody = await response.text();
    try {
      responseBody = JSON.parse(responseBody);
    } catch {
      responseBody = { result: responseBody };
    }
  } catch {
    responseBody = { message: "Network error" };
  }
  return setLastRequest({
    url,
    result: responseBody?.result ? responseBody.result : responseBody,
    status,
  });
};

export default fetchData;
